/**
 * 날짜 필드에서 월(또는 연)만 바꿔 존재하지 않는 날짜가 됐을 때, 그 달의 마지막 날로 맞춘다.
 * 예) 5월 31일에서 월을 2월로 바꾸면 → 2월 28일(윤년이면 29일)
 *
 * MUI 는 이런 입력을 Invalid Date 로 확정해 버리므로, 그대로 두면 조회에 NaN 이 실려 나간다.
 */
type DateFieldSection = { type: string; value: string }

const readSectionNumber = (sections: DateFieldSection[], type: string) => {
  const value = sections.find((section) => section.type === type)?.value

  if (!value || !/^\d+$/.test(value)) {
    return null
  }

  return Number(value)
}

/** 연/월 기준 그 달의 마지막 날짜 (month 는 1~12) */
export const getLastDayOfMonth = (year: number, month: number) => {
  // new Date(year, ...) 는 0~99 를 1900 년대로 해석하므로 setFullYear 로 연도를 넣는다.
  const probe = new Date(0)
  probe.setFullYear(year, month, 0)

  return probe.getDate()
}

/**
 * 입력 중인 섹션 값으로 유효한 날짜를 만든다. 일자가 그 달에 없으면 마지막 날로 줄인다.
 * 아직 다 입력되지 않았거나 값이 숫자가 아니면 null (호출 측에서 원래 값을 유지한다).
 */
export const clampDateFromSections = (sections: DateFieldSection[]) => {
  const year = readSectionNumber(sections, "year")
  const month = readSectionNumber(sections, "month")
  const day = readSectionNumber(sections, "day")

  if (!year || !month || !day || month < 1 || month > 12) {
    return null
  }

  const clamped = new Date(0)
  clamped.setFullYear(year, month - 1, Math.min(day, getLastDayOfMonth(year, month)))
  clamped.setHours(0, 0, 0, 0)

  return Number.isNaN(clamped.getTime()) ? null : clamped
}
